import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';

export class EmptySearchResultTracker {
  private _emptySearchResult$ = new Subject();
  private _trackingDebounceTimeout = 1000;

  get trackingDebounceTimeout() {
    return this._trackingDebounceTimeout;
  }

  constructor(private _angulartics, private _destroyed$) {
    this._emptySearchResult$.pipe(
      debounceTime(this._trackingDebounceTimeout),
      takeUntil(this._destroyed$)
    ).subscribe(({ eventName, searchText, extraProps }) => {
      this._angulartics.eventTrack.next({
        action: eventName,
        properties: {
          searchText,
          ...extraProps
        }
      });
    });
  }

  onEmptyResult(eventName, searchText, extraProps) {
    this._emptySearchResult$.next({ eventName, searchText, extraProps });
  }
}
